import { Button } from "@/components/ui/button";
import { Lock, ArrowUpRight, Sparkles, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureUpgradeCardProps {
  featureName: string;
  description?: string;
  benefits?: string[];
}

export const FeatureUpgradeCard = ({ featureName, description, benefits }: FeatureUpgradeCardProps) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 via-card to-card p-6 sm:p-8 shadow-fluent-2">
      {/* Decorative bg */}
      <div className="absolute -top-20 -right-20 h-56 w-56 rounded-full bg-primary/15 blur-3xl pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />

      <div className="relative flex items-start gap-5 flex-wrap sm:flex-nowrap">
        <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-primary to-primary-glow text-primary-foreground flex items-center justify-center shrink-0 shadow-fluent-4">
          <Lock className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <h3 className="text-xl font-semibold">{featureName}</h3>
            <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full bg-primary text-primary-foreground shadow-fluent-2">
              <Sparkles className="h-3 w-3" /> Pro
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            {description ?? `${featureName} is available on Pro plan and above. Upgrade to unlock it.`}
          </p>

          {benefits && benefits.length > 0 && (
            <ul className="mt-5 space-y-2">
              {benefits.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-sm">
                  <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                  <span className="text-foreground/80">{b}</span>
                </li>
              ))}
            </ul>
          )}

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Button asChild className="shadow-fluent-2 gap-2">
              <Link to="/plans">
                Upgrade to Pro
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to="/pricing">Compare plans</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
